import { faCircleCheck, faDollarSign, faDonate, faEnvelope, faGlobe, faHouse } from '@fortawesome/pro-light-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
export default function initiateIconLibrary() {
    library.add(faDonate, faEnvelope, faGlobe, faCircleCheck, faDollarSign, faHouse);
}
initiateIconLibrary();
